import type { User } from '../../../shared/types';

export type ProtectedRouteRedirect =
  | '/entrar'
  | '/inicio'
  | '/seguranca'
  | null;

export function getProtectedRouteRedirect(input: {
  isAuthenticated: boolean;
  user: User | null;
  requireAdmin: boolean;
}): ProtectedRouteRedirect {
  if (!input.isAuthenticated) return '/entrar';

  if (!input.requireAdmin) return null;

  if (!input.user?.isAdmin) return '/inicio';

  // SECURE-001: Client UX should guide admins to enroll MFA before reaching admin UI.
  // Server enforcement is the real boundary, but this keeps the UI flow explicit and consistent.
  if (!input.user.mfaEnabledAt) return '/seguranca';

  return null;
}

